import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Button from '../Button';
import useMediaQuery from '../../hooks/useMediaQuery';
import ArrowBtn from '../../assets/icon/ArrowBtn';
// import { useLoading } from '../../utils/useLoading';
import { productBestListSelector } from '../../store/selectors/ProductBest';
import style from './TitleTabs.module.scss';

function TitleTabs() {
    const isTablet = useMediaQuery('(min-width: 768px)');
    const [ openDropdown, setOpenDropdown ] = useState(false);

    const list = useSelector(productBestListSelector);

    const tabs = useMemo(() => {
        if (!list.length > 0) return;
        const tabsList = [];

        list.forEach(item => {
            const { catalog } = item;
            const { id, nameUa } = catalog;

            // Проверяем, есть ли уже объект с таким id в новом массиве
            const existingItem = tabsList.find(obj => obj.id === id);

            // Если объект с таким id уже существует, пропускаем его
            if (existingItem) {
                return;
            }

            // Создаем новый объект с уникальными значениями id и nameUa
            const newItem = {
                id,
                nameUa
            };

            // Добавляем новый объект в новый массив
            tabsList.push(newItem);
        });

        return tabsList;
    }, [ list ]);

    // const arr = [
    //     'Харчові добавки',
    //     'Трави та натуральні засоби',
    //     'Товари для дітей',
    //     'Товари для душу та гігієни',
    //     'Краса',
    //     'Фізична активність',
    //     'Гігієна'
    // ];

    function handleClick() {
        setOpenDropdown(prev => !prev);
    }

    return (
        <div className={style['title-tabs']}>
            <h2 className={style.title}>
                Бестселери
            </h2>

            {
                isTablet ?
                    <div className={style['title-tabs__wrapper']}>
                        {
                            tabs?.map(item => (
                                <Button key={item?.id} name={item?.nameUa} link={`catalog/${item?.id}`} />
                            ))
                        }
                    </div>

                    :

                    <div className={style.mobile}>
                        <button
                            /* eslint-disable-next-line react/jsx-no-bind */
                            onClick={() => handleClick()}
                            className={openDropdown ? style.active : ''}
                        >
                            Показати всі
                            <ArrowBtn />
                        </button>

                        <ul className={openDropdown ? style['list-open'] : ''}>
                            {
                                tabs?.map(item => (
                                    <li key={item?.id}>
                                        <Link to={`catalog/${item?.id}`}>
                                            { item?.nameUa }
                                        </Link>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
            }
        </div>
    );
}

export default React.memo(TitleTabs);

